import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { routes as allRoutes, Route } from "../routes/routes";

export const useRoute = (routes: Route[] = allRoutes): Route | null => {
    const location = useLocation();

    const matchedRoutes = useMemo(() => {
        const matchRoutes = (routes: Route[], pathname: string, parentPath = ""): Route[] => {
            const matches: Route[] = [];

            for (const route of routes) {
                // Compute the full path
                const fullPath = parentPath.replace(/\/$/, "") + "/" + route.path.replace(/^\//, "");

                // Normalize trailing slashes to ensure exact matching
                const normalizedPath = fullPath.endsWith("/") ? fullPath.slice(0, -1) : fullPath;

                // Check if the route matches
                const isMatch = pathname === normalizedPath || pathname === fullPath;

                if (isMatch) {
                    matches.push(route);
                }

                // Recursively match child routes
                if (route.children) {
                    const childMatches = matchRoutes(
                        route.children,
                        pathname,
                        fullPath.endsWith("/") ? fullPath : fullPath + "/"
                    );
                    matches.push(...childMatches);
                }
            }

            return matches;
        };

        // Get all matches and reverse for deepest-first order
        return matchRoutes(routes, location.pathname).reverse();
    }, [location.pathname, routes]);

    // Return the deepest match or null if no matches
    return matchedRoutes[0] ?? null;
};